// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import { Loader, Stack } from '@mantine/core';
import type { JSX } from 'react';
import { usePatient } from '../../../hooks/usePatient';
import { usePatientHsatOrders } from '../../../hooks/usePatientHsatOrders';
import { DmeSection } from './DmeSection';
import { HsatSection } from './HsatSection';

export function DevicesTab(): JSX.Element {
  const patient = usePatient();
  const hsat = usePatientHsatOrders(patient);

  if (!patient) {
    return (
      <Stack align="center" p="md">
        <Loader size="sm" />
      </Stack>
    );
  }

  return (
    <Stack gap="lg" p="md">
      <HsatSection patient={patient} orders={hsat.orders} loading={hsat.loading} />
      <DmeSection />
    </Stack>
  );
}
